import request from '../../../../api/request';
import { StudentFileShowResponse } from '../types';

export const STUDENT_INFO = {
  FORM_STRUCTURE:
    'teacher-portal/student-file/personal-information/form-structure',
  GET_POSTULANT: (studentId: string | number) =>
    `teacher-portal/student-file/personal-information/${studentId}/show`,
};

export function getPostulant(studentId: number | string) {
  return request<StudentFileShowResponse>(
    STUDENT_INFO.GET_POSTULANT(studentId),
  );
}
